import { render, staticRenderFns } from "./settingCard.vue?vue&type=template&id=728c835c&scoped=true&"
import script from "./settingCard.vue?vue&type=script&lang=js&"
export * from "./settingCard.vue?vue&type=script&lang=js&"
import style0 from "./settingCard.vue?vue&type=style&index=0&id=728c835c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728c835c",
  null
  
)

export default component.exports